import { useLocation } from 'react-router-dom';
import { useNoGuard } from '@/hooks/useNoGuard';

/**
 * Generic wrapper for hooks that need mock data in noguard mode
 */
export function useMockWrapper<T>(
  realHook: () => T,
  mockGenerator: (pathname: string) => T
): T {
  const location = useLocation();
  const noGuard = useNoGuard();
  
  if (noGuard) {
    return mockGenerator(location.pathname);
  }
  
  return realHook();
}